import { SupplierType } from "../../types/BuyerBriefTypes";
import {
    FINANCIAL_TOPICS,
    MARKET_TOPICS,
    PRICING_TOPICS,
    TYPE_TOPICS,
    DEEP_DIVE_TOPICS,
    TopicOption,
} from "./topicConfig";

export interface ReviewSection {
    title: string;
    included: TopicOption[];
    excluded: TopicOption[];
}

// Mirrors the section order rendered on the Research Focus step so the review
// screen matches what the user just saw.
export function getReviewSections(
    supplierType: SupplierType | undefined,
    selectedTopics: string[]
): ReviewSection[] {
    const selected = new Set(selectedTopics);
    const categoryTopics = supplierType
        ? TYPE_TOPICS.filter((t) => t.forTypes?.includes(supplierType))
        : [];
    const sections: [string, TopicOption[]][] = [
        ["Financial & Risk Intelligence", FINANCIAL_TOPICS],
        ["Market & Competitive Position", MARKET_TOPICS],
        ["Pricing & Commercial Terms", PRICING_TOPICS],
        ["Category-Specific", categoryTopics],
        ["Optional Deep Dives", DEEP_DIVE_TOPICS],
    ];
    return sections
        .filter(([, topics]) => topics.length > 0)
        .map(([title, topics]) => ({
            title,
            included: topics.filter((t) => selected.has(t.id)),
            excluded: topics.filter((t) => !selected.has(t.id)),
        }));
}
